module.exports = __webpack_public_path__ + "static/media/Gral_Mario_Guillermo_Fromow_Garcia.ad3c254b.png";